import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Clock, CheckCircle2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DayUseOptinPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/day-use-optin/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(e.response?.data?.detail || "Lien invalide"));
  }, [token]);

  const activate = async () => {
    setBusy(true);
    try { await axios.post(`${API}/day-use-optin/${token}`); setDone(true); }
    catch (e) { setError(e.response?.data?.detail || "Activation impossible"); }
    finally { setBusy(false); }
  };

  return (
    <main className="max-w-md mx-auto px-4 py-10" data-testid="day-use-optin-page">
      <div className="glass-card p-8 text-center">
        {error && <div className="text-red-600 font-bold" data-testid="day-use-optin-error">{error}</div>}
        {!error && !info && <div>Chargement...</div>}
        {info && !done && (
          <>
            <Clock size={40} className="mx-auto text-orange-500" />
            <h1 className="font-display text-2xl font-extrabold mt-3" data-testid="day-use-optin-hotel">{info.hotel?.name}</h1>
            <p className="mt-3 text-sm text-[var(--ink-soft)]">Offre « Hotel par Heure » : creneaux de {info.defaults.durees.join("/")} h entre {info.defaults.heure_debut}h et {info.defaults.heure_fin}h, -{info.defaults.reduction} % garanti, paiement sur place, annulation gratuite pour le client. Vous pourrez ajuster horaires et reduction ensuite dans votre espace.</p>
            {info.active && <p className="mt-2 text-emerald-700 text-sm font-semibold">L&apos;offre est deja active pour cet hotel.</p>}
            <button onClick={activate} disabled={busy} className="btn-primary w-full mt-6 !py-4 !text-lg" data-testid="day-use-optin-activate">{busy ? "Activation..." : "Activer en 1 clic"}</button>
          </>
        )}
        {done && (
          <div data-testid="day-use-optin-done">
            <CheckCircle2 size={44} className="mx-auto text-emerald-600" />
            <h2 className="font-bold text-xl mt-3">Offre activee !</h2>
            <p className="text-sm mt-2">Votre hotel apparait des maintenant sur <Link to="/hotel-par-heure" className="text-orange-600 font-semibold">fodindin.net/hotel-par-heure</Link>.</p>
          </div>
        )}
      </div>
    </main>
  );
}
